import { useEffect, useState } from 'react'
import { logError } from 'lib/logging'

/**
 * Fetches a presigned S3 URL for an IVR audio key.
 * Returns undefined while loading or if no key is provided.
 * Requires GET /api/dni/audio/url?key=... backend endpoint.
 */
export const useAudioPlaybackUrl = (key: string | undefined) => {
  const [url, setUrl] = useState<string | undefined>()
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!key) {
      setUrl(undefined)
      return
    }

    let cancelled = false
    setLoading(true)

    fetch(`/api/dni/audio/url?key=${encodeURIComponent(key)}`, { credentials: `include` })
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`)
        return res.json()
      })
      .then((json) => {
        if (!cancelled) setUrl(json.url)
      })
      .catch((err) => {
        if (!cancelled) {
          logError(`ivr-audio-playback`, `failed to get playback url`, { key, error: err.message })
          setUrl(undefined)
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })

    return () => {
      cancelled = true
    }
  }, [key])

  return { url, loading }
}
